import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { API, get } from 'utils/api';
import { logError } from 'utils/log';
import { createReducer } from 'utils/redux';

import type { Action, Dispatch, ThunkAction } from 'types';

const { SUBCAMPAIGNS } = API.END_POINTS;

const AGGREGATE_LOADING = 'campaign-state-statistics/AGGREGATE_LOADING';
const AGGREGATES_LOADED = 'campaign-state-statistics/AGGREGATES_LOADED';
const RESET_AGGREGATES = 'campaign-state-statistics/RESET_AGGREGATES';

const initialState = {
  isLoading: false
};

const setLoadingStatus = (type: string, status: boolean): Action => ({
  type,

  payload: {
    status
  }
});

const aggregatesLoaded = (aggregateData: {}): Action => ({
  type: AGGREGATES_LOADED,

  payload: {
    aggregateData
  }
});

export const resetAggregates = (): Action => ({
  type: RESET_AGGREGATES
});

export const fetchStats = (collectionId: number, state: string, channel: string = 'instagram'): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(resetAggregates());
  dispatch(setLoadingStatus(AGGREGATE_LOADING, true));

  try {
    const url = SUBCAMPAIGNS.getAggregatedStatistics(collectionId, state, channel);
    const response = (await get(url)) as { data: any };
    const aggregateData = response.data || {};

    dispatch(aggregatesLoaded(aggregateData));
  } catch (e) {
    logError(e);
  } finally {
    dispatch(setLoadingStatus(AGGREGATE_LOADING, false));
  }
};

export default createReducer<any, any>('subcampaignStatistics', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET_AGGREGATES]: () => initialState,
  [AGGREGATE_LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  }),
  [AGGREGATES_LOADED]: (state, { aggregateData }) => ({
    ...state,
    ...aggregateData,
    isLoading: false
  })
});
